<template>
  <div class="my-setup">
    <div class="search">
      <el-form :inline="true" :model="formInline" class="demo-form-inline" style="padding:10px 20px" size="mini" ref="formInline">
        <el-form-item label="事项名称：" prop="implName">
            <el-input v-model="formInline.implName"></el-input>
        </el-form-item>
        <el-form-item label="纠错模块：" prop="corrModuleType">
            <el-select v-model="formInline.corrModuleType">
              <el-option :label="item.name" :value="item.code" v-for="item in moduleList" :key="item.code"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="状态：" prop="flag">
            <el-select v-model="formInline.flag">
              <el-option label="待审批" value="10"></el-option>
              <el-option label="审批不予采纳" value="12"></el-option>
              <el-option label="审批采纳" value="11"></el-option>
              <el-option label="已撤回" value="13"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="日期：">
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="resetForm('formInline')">重置</el-button>
        </el-form-item>
    </el-form>
    </div>

    <div class="tab">
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
              type="index"
              label="#"
              width="50">
          </el-table-column>
          <el-table-column
              prop="implName"
              label="事项名称">
          </el-table-column>
          <el-table-column
              prop="name"
              label="纠错模块">
              <template slot-scope="scope">
                {{modeMap[scope.row.corrModuleType]}}
              </template>
          </el-table-column>
          <el-table-column
              prop="createId_dictText"
              label="纠错人">
          </el-table-column>
          <el-table-column
              prop="approveTime"
              label="审批时间">
          </el-table-column>
          <el-table-column
              prop="approveUserId_dictText"
              label="审批人">
          </el-table-column>
          <el-table-column
              prop="approveResult"
              label="采纳">
              <template slot-scope="scope">
                {{scope.row.approveResult&&scope.row.approveResult == '1' ? '是' : scope.row.approveResult == '0' ?  '否' : ''}}
              </template>
          </el-table-column>
          <el-table-column
              prop="status"
              label="审批结果">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1 && scope.row.approveResult != 0" style="margin-right: 10px;color:#43CD80">已审批</span>
                <span v-else-if="scope.row.status == 2" style="margin-right: 10px;color:#43CD80">已撤回</span>
                <span v-else-if="scope.row.approveResult == 0 && scope.row.status == 1" style="margin-right: 10px;color:#FFC125">未通过</span>
                <span v-else>待审批</span>
              </template>
          </el-table-column>
          <el-table-column
              prop="corrStatus"
              label="是否修改">
              <template slot-scope="scope">
                <span v-if="scope.row.corrStatus == 1" style="margin-right: 10px;">已修改</span>
                <span v-else>未修改</span>
                <el-button @click="edit(scope.row)" type="text" v-if="scope.row.approveResult !== 1  && scope.row.status !== null">修改</el-button>
              </template>
          </el-table-column>
          <el-table-column
              prop="address"
              label="操作">
              <template slot-scope="scope">
                <el-button @click="look(scope.row)" type="text">查看</el-button>
                <el-button @click="withdraw(scope.row)" type="text" v-if="scope.row.status == 0">撤回</el-button>
              </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top:20px"
            background
            @current-change="onSubmit"
            :total="pagination.total"
            :current-page.sync="pagination.pageNo"
            :page-size="pagination.pageSize"
            layout="prev, pager, next, jumper">
        </el-pagination>
    </div>
    <!--  弹框部分  -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%">
      <ul class="rowInfo">
        <li>
          <p><span>事项名称：</span>{{rowInfo.implName}}</p>
        </li>
        <li>
          <p><span>纠错模块：</span>{{modeMap[rowInfo.corrModuleType]}}</p>
        </li>
        <li>
          <p><span>纠错人：</span>{{rowInfo.createId_dictText}}</p>
        </li>
        <li>
          <p><span>纠错内容：</span>{{rowInfo.corrContent}}</p>
        </li>
        <li>
          <p><span>审批结果：</span>{{rowInfo.status == '0' ? '待审批' : (rowInfo.approveResult == '1' ? '已通过' : '未通过')}}</p>
        </li>
        <li>
          <p><span>审批时间：</span>{{rowInfo.updateTime}}</p>
        </li>
        <li>
          <p><span>备注：</span>{{rowInfo.remark}}</p>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="editLog"
      width="30%">
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-form-item label="事项名称">
          <el-select v-model="editForm.implId" filterable>
            <el-option :label="item.implName" :value="item.implId" v-for="item in deptList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="纠错模块">
          <el-select v-model="editForm.corrModuleType">
            <el-option :label="item.name" :value="item.code" v-for="item in moduleList" :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="纠错内容">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入内容"
            v-model="editForm.corrContent">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deitSave">确 定</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api/personApi'
export default {
    data() {
      return {
        formInline: {
          implName:'',
          corrModuleType:null,
          flag:'',
        },
        pagination: {
          pageSize: 10,
          pageNo: 1,
          total: 1
        },
        time:[],
        tableData: [],
        moduleList:[],
        modeMap:{},
        dialogVisible:false,
        editLog:false,
        rowInfo:{},
        editForm: {
          implId: '',
          corrModuleType: '',
          corrContent: '',
        },
        deptList:[]
      }
    },
    computed:{
      ...mapState(["user"]),
      userInfo(){
        return this.user.info
      },
    },
    mounted(){
      this.onSubmit()
      this.getModuledata()
      this.queryImpl()
    },
    methods: {
      onSubmit() {
        let params = {
          ...this.formInline,
          beginTime:this.time[0],
          endTime:this.time[1],
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          corrUserId:this.user.info.id,
          hallId:this.user.hallInfo.id
        }
        api.myErrlist(params).then(res => {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          // console.log(res,'查询列表')
        }).catch(err => {
          console.log(err)
        })
        console.log(params)

      },
      resetForm(formName) {
        this.time = []
        this.$refs[formName].resetFields();
      },
      // 纠错模块
      getModuledata(){
        api.myModuledata().then(res => {
          let obj = {}
          res.data.forEach(item => {
            obj[item['code']] = item['name']
          })
          this.modeMap = obj
          this.moduleList = res.data
          this.moduleList.forEach(item =>{
            if(item.code == this.rowInfo.corrModuleType){
              this.editForm.corrModuleType = this.rowInfo.corrModuleType
            }
          })
        }).catch(err => {
          console.log(err)
        })
      },
      // 撤回
      withdraw(row){
        this.$confirm('是否确认撤回?', '撤回', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            id:row.id,
            status: 0,
            corrStatus: 0,
            approveUserId: null,
            approveTime: null,
            approveResult:0
          }
          api.withdraw(params).then(res => {
            if(res.success){
              this.$message.success(res.message)
              this.onSubmit()
            }else{
              this.$message.error(res.message)
            }
          }).catch(err => {
            console.log(err)
          })
        }).catch(()=>{})
      },
      // 查看
      look(row){
        console.log(row)
        this.rowInfo = row
        this.dialogVisible = true
      },
      // 修改
      edit(row){
        this.rowInfo = row
        this.editLog = true
        this.getModuledata()
        this.queryImpl()
        this.editForm.corrContent = row.corrContent
      },
      // 根据大厅查事项
      queryImpl(){
        api.myQueryImpl({deptId:this.user.hallInfo.id}).then(res => {
          this.deptList = res.data
          this.deptList.forEach(item =>{
            if(item.implName == this.rowInfo.implName){
              this.editForm.implId = this.rowInfo.implId
            }
          })
          // console.log(res,'根据大厅查事项')
        }).catch(err => {
          console.log(err)
        })
      },
      // 修改
      deitSave(){
        let params = {
          id:this.rowInfo.id,
          ...this.editForm,
          corrUserId:this.userInfo.id
        }
        api.modify(params).then(res => {
          if(res.success){
            this.onSubmit()
            this.$message.success(res.message)
            this.editLog = false
          }else{
            this.$message.error(res.message)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
}
</script>

<style lang="less" scoped>
.my-setup{
    /* background: #fff; */
    // margin-top: 20px;
}
.search{
  background: #fff;
}
.tab{
    text-align: right;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
}
.rowInfo{
  li{
    list-style: none;
    line-height: 2;
    p{
      display: flex;
      align-items: center;
      span{
        width: 25%;
      }
    }
  }
}
</style>